module.exports = __webpack_public_path__ + "images/emoji/ant.34fd5d4bac24fba37852.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ant.png
// module id = Vex6
// module chunks = 24